import React from 'react';
import { observer } from 'mobx-react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { routeNode } from 'core/routing';
import { FourOhFour } from 'apps/fourOhFour/index';
import { Profile } from 'apps/profile/main/index';
// import { ProfileSettingsRouter } from 'apps/profile/settings/router';
import { ProfileProjectRouter } from 'apps/project/router';
import { ProfileSharedFileRouter } from 'apps/share/router';
import { ProfileStoryRouter } from 'apps/story/main/router';
import { CollectionPage } from 'apps/collection/main/index';
import { InvitationsPage } from 'apps/profile/invitations/index';
import { useRouterStore } from 'apps/hooks';
import { useAppManager } from 'core/hooks';
import { Tabs, Tab } from 'components';
import ProfileIntro from 'apps/profile/main/intro';
import ProfileStories from 'apps/profile/main/ProfileStories';
import ProfileProjects from 'apps/profile/main/ProfileProjects';
import ProfileThreads from 'apps/profile/main/ProfileThreads';
import ProfileCollections from 'apps/profile/main/ProfileCollections';
import { ProfileAppManager } from 'apps/profile/main/appManager';
import { MainWrapper } from 'legacyComponents/styled/lib';

import { Folder, Stories, Threads, Collections } from 'icons';

const viewsMap = {
  '': Profile, // route soft redirected by router to /projects
  // settings: ProfileSettingsRouter,
  project: ProfileProjectRouter,
  shared: ProfileSharedFileRouter,
  story: ProfileStoryRouter,
  collection: CollectionPage,
  invitations: InvitationsPage,

  projects: ProfileProjects,
  stories: ProfileStories,
  threads: ProfileThreads,
  collections: ProfileCollections,
};

const profilePageRoutes = [
  'profile',
  'profile.projects',
  'profile.stories',
  'profile.threads',
  'profile.collections',
];

const TabsWrapper = styled.div(({ theme }) => ({
  marginTop: theme.spacing.large,
}));

const ProfileSpace = observer(props => {
  let View = props.componentFromRoute();
  const { route, params, router } = useRouterStore();

  const isProfilePage = profilePageRoutes.includes(route.name);
  const appManager = useAppManager(
    ProfileAppManager,
    null,
    {
      params,
      routeName: route.name,
      ...props,
    },
    isProfilePage,
  );

  if (!isProfilePage) {
    return <View params={params} routeName={route.name} />;
  }

  let segment;
  [, segment] = route.name.split('.'); // workspace.segment
  if (!segment) {
    // if in 'profile' route then render contents of profile.projects
    segment = 'projects';
    View = viewsMap[segment] || FourOhFour;
  }

  let tabsValue = route.name;
  if (tabsValue === 'profile') tabsValue = 'profile.projects';
  const tabs = (
    <Tabs
      value={tabsValue}
      onClick={(event, value) => {
        router.navigate(value, {
          profile: route.params.profile,
        });
      }}
    >
      <Tab value='profile.projects' icon={<Folder />}>
        Projects
      </Tab>
      <Tab value='profile.stories' icon={<Stories />}>
        Stories
      </Tab>
      <Tab value='profile.threads' icon={<Threads />}>
        Threads
      </Tab>
      <Tab value='profile.collections' icon={<Collections />}>
        Collections
      </Tab>
    </Tabs>
  );
  return (
    <>
      <ProfileIntro
        params={params}
        routeName={route.name}
        appManager={appManager}
      />
      {appManager.profile && (
        <>
          <TabsWrapper>
            <MainWrapper>{tabs}</MainWrapper>
          </TabsWrapper>
          <View
            params={params}
            routeName={route.name}
            appManager={appManager}
          />
        </>
      )}
    </>
  );
});

ProfileSpace.propTypes = {
  componentFromRoute: PropTypes.func,
};

export const ProfileRouter = routeNode(
  'profile',
  viewsMap,
  FourOhFour,
)(ProfileSpace);
